export enum ExternalProvider {
  Google = 'Google',
  Facebook = 'Facebook',
  Apple = 'Apple',
}
